import React, { useRef, Fragment, useEffect, useState } from "react";
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import {
  Button, TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, IconButton,
  colors, Typography, Grid,  Divider,
} from '@material-ui/core';
import ReactToPrint from 'react-to-print';
import {Close} from '@material-ui/icons';
import { BorderTop, Cancel, Print } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  btnAceptar: {
    color: colors.green[500],
  },
  btnCancelar: {
    color: colors.red[500],
  },
  divTopButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  btnClose: {
    '&:hover': { color: 'red', cursor: 'pointer' }
  },
  yourClassName: {
    ['@media screen']: { // eslint-disable-line no-useless-computed-key
      display: 'none'
    }
  },
   typo: {
    flexGrow: 1,
    textAlign: "center",
    fontWeight: 600,
  }
}));
const ModalPrint = (props) => {
  const { open, titulo, ContenidoMensaje, OnCerrar, width, skroll, acciones, children, paddingDisabled,info, tipo } = props;
  // console.log(tipo);
  const classes = useStyles();
  const pageStyle = "@page { size: 8.5 in,hyphens:auto }";
  var componentPrint = useRef();
  
  return (
    <Dialog
      open={open}
      // onClose={OnCerrar} 
      fullWidth maxWidth={width}
      scroll={skroll}
      aria-labelledby="form-dialog-title">
      <div className={classes.divTopButtons} >
        <ReactToPrint
          pageStyle={pageStyle}
          trigger={() => {
            return (
              <IconButton type="submit" title="imprimir" className={classes.btnPrint} aria-label="imprimir">
                <Print target="_blank" style={{ pointerEvents: '', cursor: '' }} />
              </IconButton>
            );
          }}
          // onBeforePrint={() => datos.imprAutorizada == null && datos.idestatus == "3" ?guardarImprAutorizada(datos):null}
          content={() => componentPrint}
        />
          <IconButton type="submit" title="cerrar" onClick={OnCerrar} className={classes.btnClose} aria-label="cerrar">
            <Cancel />
          </IconButton>
      </div>
      <DialogTitle>
        <Grid container item xs={12}>
          <Grid item xs={12}>
            {info && <Typography  variant="h3" className={classes.typo}>{info.titulo}</Typography>}
          </Grid>

        </Grid>
      </DialogTitle>
      <DialogContent style={paddingDisabled ? { paddingLeft: 0, paddingRight: 0 } : {}}>
        <DialogContentText>
          {ContenidoMensaje}
          
{/* className={classes.yourClassName} */}
<div  style={{padding: "20px" , marginTop : "30px",maxWidth:'8.5 in', pageBreakInside : 'avoid'}} className={classes.yourClassName} >
          <Grid container className={classes.root} spacing={2}  ref={el => (componentPrint = el)} >
            <Grid item md={12} xs={12}>

              {info && <Typography  variant="h3" className={classes.typo}>{info.titulo}</Typography>}
              
            </Grid>
            <Grid item md={5} xs={5}>
              <Typography variant="body2" className={classes.bold}>
                FECHA DE INICIO:
              </Typography>
              {info && <Typography variant="body2">{info.fecha_inicio || "N/D"}</Typography>}
            </Grid>
            <Grid item md={4} xs={4}>
              <Typography variant="body2" className={classes.bold}>
                FECHA DE TÉRMINO:
              </Typography>
              {info && <Typography variant="body2"> {info.fecha_termino || "N/D"}</Typography>}
            </Grid>
            <Grid item md={3} xs={3}>
              <Typography variant="body2" className={classes.bold}>
                NO. DE HORAS:
              </Typography>
              <Typography variant="body2">
                {tipo ? (tipo == "seguimiento" ? info.nhoras_seguimiento : info.nhoras_incidencia) : "N/D"}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <Typography variant="body2" className={classes.bold}>
                EXTERNOS:
              </Typography>
              {info && <Typography variant="body2">{info.involucrados}</Typography>}
            </Grid>

            <Grid item md={12} xs={12}>
              <Typography variant="body2" className={classes.bold}>
                MIEMBROS DE EQUIPO:
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
                {info?.personas
                  ? info.personas.map(
                    (persona, index) => (
                      <React.Fragment>
                        <Typography variant="body2">
                          {index + 1 + ". " + persona.nombre}
                        </Typography>
                        <Divider />
                      </React.Fragment>
                    )
                    // )
                  )
                  : "N/D"}

            </Grid>
            <Grid item md={12} xs={12}>
              <Typography variant="body2" className={classes.bold}>
                DESCRIPCIÓN:
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
                <Typography variant="body2">{tipo ? (tipo == "seguimiento" ? info.observaciones : info.descripcion) : "N/D"}</Typography>
            </Grid>
          </Grid>
          </div>
        </DialogContentText>
        <div className='MuiDialogContentText-root' >
          {children}
        </div>
      </DialogContent>
      <DialogActions>
        {acciones}
      </DialogActions>
    </Dialog>
  );
}
ModalPrint.propTypes = {
  open: PropTypes.bool.isRequired,
  titulo: PropTypes.string.isRequired
  , ContenidoMensaje: PropTypes.string
  , form: PropTypes.node,
  acciones: PropTypes.element.isRequired,
  paddingDisabled: PropTypes.bool,

}
ModalPrint.defaultProps = {
  width: "sm",
  skroll: 'paper',
  paddingDisabled: false
};
export default ModalPrint;